import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let banner = new Swiper(".banner__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 8000,
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let videoSwiper = new Swiper(".video__slider", {
        watchOverflow: true,
        navigation: {
            nextEl: '.swiper-button-next.video-n',
            prevEl: '.swiper-button-prev.video-p',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let partners = new Swiper(".partners__slider", {
        watchOverflow: true,
        slidesPerView: 6,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            1199: {
                slidesPerView: 5,
            },
            900: {
                slidesPerView: 4,
            },
            600: {
                slidesPerView: 2,
            },
        },
    });
    
    let photoSlider = new Swiper(".photo__slider", {
        centeredSlides: true,
        loop: true,
        speed: 1000,
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            delay: 3400
        },
        navigation: {
            nextEl: '.photo-button-next',
            prevEl: '.photo-button-prev',
        },
        breakpoints: {
            1400: {
                slidesPerView: 3
            },
            1199: {
                slidesPerView: 3
            },
            800: {
                slidesPerView: 1
            }
        }
    });
};
